module.exports = __webpack_public_path__ + "static/salt_mobile-1f42634226ffb1778aaca12205b21300.png";